/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Formik } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import * as yup from 'yup';
import Layout from 'components/Layout';
import StepNavigation from 'components/StepNavigation'
import Loader from 'components/Loader';
import Row from "components/Grid/Row";
import Col from "components/Grid/Col";
import BrokingSummary from 'components/BrokingSummary';
import { FitinsurAPI, MessageCenter } from 'utils';
import MasksHelper from 'utils/src/masks';
import Colors from 'constants/Colors';
import {
  FormSection,
  Button,
  ButtonContainer,
  LostCancelButton,
  HasPermission,
  FormContainer,
  Clauses
} from '@fitinsur/components';
import {
  AuthContext,
  LoaderContext
} from '@fitinsur/contexts'
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import {
  Content,
  ButtonContent
} from './styles';
import { isNumber } from '@fitinsur/utils';
import { useGenerateQuote } from 'services/QuoteService';
import {
  useGetQuestionnaireAnswer,
  useSaveQuestionnaireAnswer,
} from 'services/QuestionnaireAnswerService';
import { onValidationError } from 'containers/edit/handleQuestionChange';
import { useGetOperation } from 'services/OperationService';
import { useGetDocuments } from 'services/DocumentsService';

export default function QuoteLetter({ permissions, ...props }) {
  const { updateIsLoadingStatus } = useContext(LoaderContext);
  const validationSchema = useRef(yup.object().shape({}));
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const formikRef = useRef({});
  const location = useLocation();
  const handleBack = () => history.goBack();
  const maskHelper = new MasksHelper();
  const goToNextPage = useRef(false);

  const [isBound, setIsBound] = useState(true);
  const [operation, setOperation] = useState(null);
  const [initialValues, setInitialValues] = useState({});
  const [questionnaire, setQuestionnaire] = useState([]);
  const [fullCoverageList, setFullCoverageList] = useState([]);
  const [groupDeductible, setGroupDeductible] = useState([]);
  const [hasCoverageCalc, setHasCoverageCalc] = useState(false);
  const [clausesLoading, setClausesLoading] = useState(false);
  const [idProductPlan, setIdProductPlan] = useState(0);
  const [coverageCalcList, setCoverageCalcList] = useState([{
    coverageCalc: [{
      coverageLimit: "0",
      coveragePremium: "0",
      coverageAmount: "0",
      coverageComissionRate: "0",
      coverageComission: "0",
      coverageTax: "0",
      coverageAmountTaxLess: "0",
      deductibleDescription: "",
      coverageItems: []
    }]
  }]);

  const SECTIONS = {
    QUOTE_LETTER: { name: 'QUOTE_LETTER', isMultiple: false, isRisk: false }
  };

  const {
    data: useGetDocumentsData,
    loading: useGetDocumentsLoading,
    error: useGetDocumentsError,
    status: useGetDocumentsStatus,
    request: useGetDocumentsRequest
  } = useGetDocuments(props.match.params.idOperation);

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    error: useGetQuestionnairesAnswersError,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props?.match?.params?.idOperation);

  const {
    data: useSaveQuestionnaireAnswerData,
    loading: useSaveQuestionnaireAnswerLoading,
    error: useSaveQuestionnaireAnswerError,
    status: useSaveQuestionnaireAnswerStatus,
    request: useSaveQuestionnaireAnswerRequest,
  } = useSaveQuestionnaireAnswer(props?.match?.params?.idOperation);

  const {
    data: useGenerateQuoteData,
    loading: useGenerateQuoteLoading,
    error: useGenerateQuoteError,
    status: useGenerateQuoteStatus,
    request: useGenerateQuoteRequest
  } = useGenerateQuote(props?.match?.params?.idOperation);


  const {
    data: useGetOperationData,
    loading: useGetOperationLoading,
    error: useGetOperationError,
    status: useGetOperationStatus,
    request: useGetOperationRequest,
  } = useGetOperation(props?.match?.params?.idOperation);

  const handleQuestionnaire = async (data) => {
    let questionnaire = [];
    questionnaire = [
      ...data.persons,
      ...data.operations,
      ...data.payments,
      ...data.risks
    ];

    questionnaire = questionnaire.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);

    setQuestionnaire(questionnaire);
  }

  const buildValidation = () => {
    const validationSchema = {};

    const fieldErrorMessage = (question) => {
      mc.error(`O Campo: ${question.dsQuestion} é Obrigatório`);
      return "* Campo Obrigatório"
    };

    const questionnaire = handleSaveQuestionnaireAnswer(formikRef?.current?.values, false, true);
    for (const question of questionnaire) {
      if (!question.key || question.behaviorObject.sectionName === "INSURED") continue;
      validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired ? yup.string().required(() => fieldErrorMessage(question)) : yup.string().notRequired();
    }
    return yup.object().shape(validationSchema);
  }

  const handleGenerateQuote = (values) => {
    buildValidation().validate(values, { abortEarly: false })
      .then(() => {
        handleSaveQuestionnaireAnswer(values, props.match?.params?.idOperation)
      })
      .catch((e) => {
        onValidationError(e, mc, formikRef, questionnaire, [])
      })
  }

  const parseNumber = (value) => {
    if (typeof (value) === 'string') {
      if (value.startsWith('%')) return Number(value.replaceAll('%', '').replaceAll(',', '.'))

      return Number(value.replaceAll('R$', '').replaceAll('.', '').replaceAll(',', '.'))
    }
    return value
  }

  const handleGetQuote = async (documentCoverageList, previousCalculation, indexCoverageCalcList) => {
    const chosenDeductible = isNumber(indexCoverageCalcList) ?
      indexCoverageCalcList : formikRef.current?.values?.optionDeductible;

    let calculations = documentCoverageList.coverageCalcList[0].coverageCalc ?
      documentCoverageList.coverageCalcList[chosenDeductible].coverageCalc :
      documentCoverageList.coverageCalcList;

    calculations = calculations.map((calculation, index) => {
      calculation.productPlanName = documentCoverageList.coverageCalcList[0].coverageCalc ?
        documentCoverageList.coverageCalcList[chosenDeductible].idProductPlanName :
        documentCoverageList.idProductPlanName;
      calculation.idProductPlan = documentCoverageList.coverageCalcList[0].coverageCalc ?
        documentCoverageList.coverageCalcList[chosenDeductible].idProductPlan :
        documentCoverageList.idProductPlan;
      calculation.option = index;
      calculation.deductibleDescription = String(calculation.deductibleDescription || 0.0);
      calculation.coverageComissionRate = (parseNumber(calculation.coverageComissionRate || 0.0) * 100).toFixed(5);

      calculation.coverageItems = calculation.coverageItems.map((coverage) => {
        coverage.coveragePremium = String(coverage.coveragePremium || 0.0);
        coverage.coveragePremiumDiscountLess = String(coverage.coveragePremiumDiscountLess || 0.0);
        coverage.coveragePremiumTaxLess = String(coverage.coveragePremiumTaxLess || 0.0);
        coverage.coveragePremiumDiscountRate = ((coverage.coveragePremiumDiscountRate || 0.0) * 100).toFixed(
          +props.match?.params?.idProduct === 34 ? 6 : 2
        );
        coverage.coverageDisabled = coverage.coverageDisabled;
        coverage.coverageLimit = String(coverage.coverageLimit ? parseNumber(coverage.coverageLimit || 0.0) : parseNumber(calculation.coverageLimit));
        coverage.deductibleDescription = String(coverage.deductibleDescription ? coverage.deductibleDescription : "");
        coverage.coverageMaxLimClaim = String(coverage.coverageMaxLimClaim ? parseNumber(coverage.coverageMaxLimClaim || 0.0) : parseNumber(calculation.coverageMaxLimClaim));
        coverage.coverageMaxLimClaimRate = (coverage.coverageMaxLimClaimRate ?
          parseNumber(coverage.coverageMaxLimClaimRate || 0.0) * 100 :
          (coverage.coverageMaxLimClaim / coverage.coverageLimit) * 100).toFixed(2);

        return coverage;
      });
      return calculation;

    })

    setIdProductPlan(calculations[0].idProductPlan);
    setCoverageCalcList(calculations);
  }

  const handleSaveQuestionnaireAnswer = (values, idOperation, onlyQuestions) => {
    const formValues = JSON.parse(JSON.stringify(values));

    const body = { questionnaireAnswers: [] };
    for (const [key, section] of Object.entries(SECTIONS)) {
      if (section.isMultiple) {
        let multipleFields = []
        switch (section.name) {
          default:
            multipleFields = [];
            break;
        }

        multipleFields.map((field, index) => {
          let sectionAnswers = formValues[`$ANSWERS_${section.name}_${index}`];
          if (sectionAnswers?.length) {
            const rootQuestion = sectionAnswers.find(question => !question.idQuestionRoot);
            const childrenQuestions = sectionAnswers.filter(question => question.idQuestionRoot);
            rootQuestion.childrenQuestions = childrenQuestions
            if (!onlyQuestions) {
              body.questionnaireAnswers = [...body.questionnaireAnswers, rootQuestion];
            } else {
              body.questionnaireAnswers = [...body.questionnaireAnswers, ...sectionAnswers];
            }
          }
        })
      } else {
        let sectionAnswers = formValues[`$ANSWERS_${section.name}`];
        if (sectionAnswers) {
          body.questionnaireAnswers = [...body.questionnaireAnswers, ...sectionAnswers];
        }
      }
    }

    for (const question of body.questionnaireAnswers) {
      if ((question.idDomainQuestion === 270 || question.idDomainQuestion === 271) && question.answer) {
        try {
          question.answer = JSON.stringify(question.answer)
        } catch (e) {
        }
      }
    }

    if (onlyQuestions) return body.questionnaireAnswers;

    if (idOperation) {
      useSaveQuestionnaireAnswerRequest(body.questionnaireAnswers);
    }
  }

  useEffect(() => {
    updateIsLoadingStatus(
      useGetQuestionnairesAnswersLoading ||
      useSaveQuestionnaireAnswerLoading ||
      useGenerateQuoteLoading ||
      useGetOperationLoading ||
      useGetDocumentsLoading
    )
  }, [
    useGetQuestionnairesAnswersLoading,
    useSaveQuestionnaireAnswerLoading,
    useGenerateQuoteLoading,
    useGetOperationLoading,
    useGetDocumentsLoading
  ]);

  useEffect(() => {
    useGetOperationRequest();
    useGetQuestionnairesAnswersRequest(null, { idDomainStatus: null });
    useGetDocumentsRequest(null, { idDomain: 261 });
  }, []);

  useEffect(() => {
    if (useGetQuestionnairesAnswersStatus === 200) {
      handleQuestionnaire(useGetQuestionnairesAnswersData?.value)
    }
  }, [useGetQuestionnairesAnswersStatus]);

  useEffect(() => {
    if (useSaveQuestionnaireAnswerStatus === 200) {
      if (!goToNextPage.current) {
        mc.success('informações salvas com sucesso!');
        return history.push('/list');
      }

      const questionnaire = handleSaveQuestionnaireAnswer(formikRef?.current?.values, false, true);
      const finishedAnalisys = questionnaire.find(q => q.idQuestion == 1208)?.idAnswerOption === 6131;

      useGetQuestionnairesAnswersRequest(null, { idDomainStatus: null });

      useGenerateQuoteRequest({ 
        idDomainStatus: finishedAnalisys ? 16 : 19,
        idProductPlanSelected: operation?.operationMetadata?.idProductPlanSelected
      })
    }
  }, [useSaveQuestionnaireAnswerStatus]);

  useEffect(() => {
    if (useGenerateQuoteStatus === 200) {
      history.push(`/quote/document/${props?.match?.params?.idOperation}`);
    }
  }, [useGenerateQuoteStatus]);

  useEffect(() => {
    if (useGetOperationStatus === 200) {
      setOperation(useGetOperationData.value)
    }
  }, [useGetOperationStatus]);

  useEffect(() => {
    buildValidation();
  }, [questionnaire]);

  useEffect(() => {
    if (useGetDocumentsStatus === 200 && useGetOperationStatus === 200) {
      //Operation
      const operationData = useGetOperationData.value;
      setOperation(operationData);
      setIsBound([5, 2, 6].includes(operationData?.idDomainStatus));

      //Quote Document
      const [quoteRequestDocument] = useGetDocumentsData.value;
      setFullCoverageList(quoteRequestDocument.documentCoverageList);
      setHasCoverageCalc(quoteRequestDocument.documentCoverageList.coverageCalcList[0].coverageCalc);
      const coverageCalcList = quoteRequestDocument.documentCoverageList?.coverageCalcList;

      //Franchises
      let indexCoverageCalcList = null;
      if (coverageCalcList) {
        indexCoverageCalcList = coverageCalcList.findIndex(
          coverage => coverage.idProductPlan === operationData?.operationMetadata?.idProductPlanSelected
        );

        if (indexCoverageCalcList !== -1) {
          formikRef.current.setFieldValue('optionDeductible', String(indexCoverageCalcList))
        } else {
          indexCoverageCalcList = null;
        }

        const deductibles = coverageCalcList.map((cov, index) => {
          const coverage = cov.coverageCalc ? cov.coverageCalc[0] : '';
          return {
            value: String(index),
            label: coverage.deductibleDescription
          }
        }).filter((item, index, self) => index === self.findIndex(
          arr => arr.label === item.label && arr.label === item.label
        ));

        setGroupDeductible(deductibles);
      }

      handleGetQuote(quoteRequestDocument.documentCoverageList, null, indexCoverageCalcList);
    }
  }, [useGetDocumentsStatus, useGetOperationStatus])

  return (
    <Layout
      title={"Analise da Cotação"}
      subtitle={`${operation?.productName || ""}`}
    >
      <Row>
        <Col>
          <StepNavigation
            stage={2}
            idOperation={props.match?.params?.idOperation}
            idProduct={props.match?.params?.idProduct}
            permissions={permissions}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <BrokingSummary
            idOperation={props.match?.params?.idOperation}
            idProduct={props.match?.params?.idProduct} />
        </Col>
      </Row>

      <Content>
        <Formik
          validateOnChange={false}
          innerRef={formikRef}
          initialValues={initialValues}
          validationSchema={validationSchema.current}
          enableReinitialize={true}
          onSubmit={() => true}
        >
          {({ values, setFieldValue }) => {
            return (
              <Form>
                <FormContainer title="Informações da carta de cotação">
                  <div style={{
                    marginTop: 25
                  }}>
                    {coverageCalcList.map((calc, index) => {
                      if (calc?.idProductPlan && !index) {
                        return (
                          <Clauses
                            idOperation={calc.idOperation}
                            idProduct={calc.idProduct || operation?.idProduct}
                            idProductPlan={calc.idProductPlan}
                            isInAnalysis={true}
                            permission={false}
                            isLoading={(isLoading) => setClausesLoading(isLoading)}
                          />
                        )
                      }
                      return <></>;
                    })}
                  </div>
                  <FormSection
                    sectionName="QUOTE_LETTER"
                    questionnaire={questionnaire}
                    values={values}
                    setFieldValue={setFieldValue}
                    ignoreModality
                    idProduct={props.match.params.idProduct}
                  />
              </FormContainer>


                <ButtonContainer>
                  <Button forth style={{ width: 'auto' }} onClick={() => handleBack()}> &lt; VOLTAR </Button>
                  <HasPermission permission={permissions.NBI_REQUEST_APPROVE_REJECT}>
                    <ButtonContent>
                      <LostCancelButton idQuestion={697} idOperation={props.match?.params?.idOperation} />
                      <Button
                        id="btnContinue"
                        type="submit"
                        onClick={() => {
                          goToNextPage.current = false;
                          handleSaveQuestionnaireAnswer(values, props.match?.params?.idOperation)
                        }}
                        style={{ marginLeft: 15 }}
                        secondary
                      >
                        SALVAR
                      </Button>

                      <Button
                        id="btnContinue"
                        type="submit"
                        onClick={() => {
                          validationSchema.current.validate(values)
                            .then(() => {
                              goToNextPage.current = true;
                              handleGenerateQuote(values)
                            })
                            .catch((e) => {
                              console.log('validation error', e)
                            })
                        }}
                        style={{ marginLeft: 15 }}
                        primary
                      >
                        GERAR COTAÇÃO
                      </Button>
                    </ButtonContent>
                  </HasPermission>
                </ButtonContainer>
              </Form>
            )
          }}
        </Formik>
        {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
      </Content>
    </Layout >
  )
}